import { TweenMax } from 'gsap';

const sidenotes = [...document.querySelectorAll('.sidenote')];

const Sidenotes = {
    init() {
        if (sidenotes.length > 0) {
            sidenotes.forEach((sidenote, index) => {
                const sideBlock = document.querySelectorAll('.text__sidenote')[index];

                if (sideBlock) {
                    TweenMax.set(sideBlock, { y: sidenote.offsetTop });

                    sidenote.addEventListener('mouseenter', () => {
                        sideBlock.classList.add('active');
                    });

                    sidenote.addEventListener('mouseleave', () => {
                        sideBlock.classList.remove('active');
                    });
                }
            });
        }
    },
};

export default Sidenotes;
